export default ra => ({
  async linkClicked (referrer) {
    await ra.track('Referral Link Clicked', {
      referrer
    })
  }
})